import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

/**
 * SkinsBack API
 * Пополнение баланса скинами Steam через внешний сервис
 */

const normalizeSkinsCreateError = (response) => {
  if (!response?.error) return null

  if (response.error === 'error backend') return 'BACKEND_ERROR'

  return response.error
}

/**
 * Создать ссылку на пополнение скинами
 * POST /api/skinsback/
 */
export const createSkinsPaymentLink = async () => {
  try {
    const response = await apiService.makeRequest('/api/skinsback/', {
      method: 'POST'
    })

    const normalizedError = normalizeSkinsCreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) {
      return { link: response.link }
    }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating skins payment link:', error)
    throw error
  }
}

/**
 * Открыть ссылку оплаты через Telegram WebApp API
 */
export const openSkinsPayment = (paymentLink, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(paymentLink, onRedirect, 'Skins', paymentWindow)
}

export default {
  createSkinsPaymentLink,
  openSkinsPayment
}
